/**
 * SVG path constants for ComingSoon tooltip component
 * These paths define the button-like shape with shadow and border effects
 */
export const COMING_SOON_PATHS = {
  /**
   * Main button shape with gradient fill
   */
  main: 'M339 31C350.117 31 359.13 40.0125 359.13 51.13V87.37C359.13 98.4875 350.117 107.5 339 107.5H20.13C9.01251 107.5 0 98.4875 0 87.37V51.13C0 40.0125 9.0125 31 20.13 31L51.9998 0L82.4998 31H339Z',

  /**
   * Border outline shape
   */
  border:
    'M342.602 34.5C353.722 34.5 362.732 43.51 362.732 54.63V101.37C362.732 112.49 353.722 121.5 342.602 121.5L24.13 122.5C13.01 122.5 4 113.49 4 102.37V55.63C4 44.51 13.01 35.5 24.13 35.5L342.612 34.5M342.602 30.5L87.5 31.5L56 1.90735e-06L24.13 31.5C10.82 31.5 0 42.32 0 55.63V102.37C0 115.68 10.82 126.5 24.13 126.5L342.612 125.5C355.922 125.5 366.742 114.68 366.742 101.37V54.63C366.742 41.32 355.922 30.5 342.612 30.5H342.602Z',

  /**
   * Shadow/background shape
   */
  shadow:
    'M24.1299 33.5H340.37C352.58 33.5 362.5 43.42 362.5 55.63V100.87C362.5 113.08 352.58 123 340.37 123H24.1299C11.9199 123 1.99989 113.08 1.99989 100.87V55.63C1.99989 43.42 11.9199 33.5 24.1299 33.5Z'
} as const;
